
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/DebouncedModel.js");
var isObject = require("isobject");

// TODO: Be more smart with added and removed events

/**
 * Keeps track of the user list, and the users' data
 * @type {Model}
 */
module.exports = Model({
	name: "managementrequests",
	init: init,
	listeners: listeners,
	triggers: triggers,
	debounce: 100, // Debounce pushes by 100 milliseconds

});

function init() {
	this.push({
		incoming: [],
		outgoing: [],
		search: [],
		denying: undefined,
		isEmail: true,
		section: "byName",
	});
}

function listeners() {
	return {
		"incomingmanagementrequests:updated": handle_incoming_requests_update,
		"outgoingmanagementrequests:updated": handle_outgoing_requests_update
	};
}

function triggers() {
	return {
		"search": handle_management_trigger_search,
		"search:clear": clear_search,
		"request": handle_trigger_management_request,
		"accept": handle_trigger_accept,
		"deny": handle_trigger_deny,
		"deny:confirm": handle_trigger_deny_confirm,
		"deny:cancel": handle_trigger_deny_cancel,
		"cancel": handle_trigger_cancel,
		"section": handle_trigger_section
	};
}

function handle_trigger_accept(data) {
	this.emit("save:trigger:start");
	var request = data.request;
	this.api.manage.requests.accept(request)
		.catch(console.error.bind(console))
		.then(requestFinished.bind(this));
}

function handle_trigger_deny(data) {
	this.extend({
		denying: data
	});
}

function handle_trigger_deny_confirm(data) {
	this.emit("save:trigger:start");
	var who = data.who;
	var request = data.request;
	var block = data.block;

	this.api.manage.requests
		.deny(request)
		.then(handle_deny_success.bind(this))
		.catch(console.error.bind(console))
		.then(requestFinished.bind(this));

	if (block)
		this.emit("blocking:trigger:block", {
			who: who
		});
}

function handle_trigger_deny_cancel() {
	this.extend({
		denying: null,
	});
}

function handle_deny_success() {
	this.extend({
		denying: null,
	});
}

function handle_trigger_cancel(data) {
	this.emit("save:trigger:start");
	var request = data.request;

	this.api.manage.requests.cancel(request)
		.catch(console.error.bind(console))
		.then(requestFinished.bind(this));
}

function handle_management_trigger_search(data) {
	var query = data.query;
	this.api.people.search(query)
		.then(filterOutSelf.bind(this))
		.then(update_search_results.bind(this, query))
		.catch(console.error.bind(console));
}

function filterOutSelf(results) {
	var ownId = this.config.id;
	return results.filter(function(result){
		return result._id !== ownId;
	});
}

function update_search_results(query, results) {
	this.extend({
		query: query,
		search: results
	});
}

function handle_trigger_management_request(who) {
	this.emit("save:trigger:start");
	if (isObject(who)) who = who.who; // When passed in an object
	var token = this.config.token;
	this.api.manage.requests.send(who, token)
		.then(dispatch_added.bind(this, who))
		.then(clear_search.bind(this))
		.catch(console.error.bind(console))
		.then(requestFinished.bind(this));
}

function requestFinished() {
	this.emit("save:trigger:finish");
}

function dispatch_added(who) {
	this.dispatch("added", {
		who: who
	});
}

function handle_trigger_section(data) {
	var section = data.name;
	this.extend({
		section: section,
		search: [],
		query: ""
	});
}

function clear_search() {
	this.extend({
		search: [],
		section: "byName",
		isEmail: false,
		query: ""
	});
}


function handle_incoming_requests_update(incoming) {
	this.extend({
		incoming: incoming
	});
}

function handle_outgoing_requests_update(outgoing) {
	this.extend({
		outgoing: outgoing
	});
}
